module.exports = __webpack_public_path__ + "assets/img/756fb1c8fd0dc6baa95dad337bc380b8.png";